import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const priceItemApi = {
  create (params) {
    return axios.post(
      `${ApiSetting.baseUrl}/api/priceitems/`, querystring.stringify(params))
  }
}

export default priceItemApi
